<template>
  <div class="tabs">
    <div class="tabs-container" :style="widthStyle">
      <ul class="tabs-list">
        <li
          class="tabs-tab"
          :class="{ isActive: tab.id === activeTabId }"
          v-for="tab in options"
          :key="tab.id"
        >
          <span @click.prevent="changeTab(tab)" tabindex="0" @keydown.enter.stop="changeTab(tab)">{{
            tab.title
          }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import {IOption} from "@/components/elements/types/IOption";

export default defineComponent({
  data() {
    return {
      activeTabId: "",
    };
  },
  props: {
    options: {
      type: Array as () => IOption[],
      required: true,
      default: () => {},
    },
    innerWidth: {
      type: Number,
      default: 1080,
    },
    default: {
      type: String,
    },
  },
  mounted() {
    if (this.options.length) this.activeTabId = this.default || this.options[0].id;
  },
  computed: {
    widthStyle(): { maxWidth: string } {
      return {
        maxWidth: this.innerWidth + "px",
      };
    },
  },
  methods: {
    changeTab(tab: IOption) {
      this.activeTabId = tab.id;
      this.$emit("change", tab);
    },
  },
});
</script>

<style lang="scss" scoped>
$color-tabs-inactive: #727272;

.tabs {
  border-bottom: 1px solid $color-primary-blue;
  max-width: 100%;
  padding: 0 30px;

  &-container {
    margin: 0 auto;
    overflow-x: scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &-list {
    display: flex;
  }

  &-tab {
    &.isActive {
      span,
      span:hover {
        color: $color-primary-blue;
        border-bottom-color: $color-primary-blue;
      }
    }

    span {
      transition: all 0.2s ease;
      color: $color-tabs-inactive;
      display: block;
      width: 100%;
      height: 100%;
      padding: 20px 0;
      font-weight: bold;
      border-bottom: 4px solid transparent;
      white-space: nowrap;
      cursor: pointer;

      &:hover {
        border-bottom-color: $color-secondary-bluegray;
      }
    }

    & + .tabs-tab {
      margin-left: 24px;
    }
  }
}
</style>
